<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Radio/NewDSimpleRadioPreview'
export default {
  name: 'NewDCommentSettingPreview',
  extends: compoment
}
</script>
